import { render, staticRenderFns } from "./PripadyWizardSumarDodatocneInfo.vue?vue&type=template&id=f939fa42&"
import script from "./PripadyWizardSumarDodatocneInfo.vue?vue&type=script&lang=js&"
export * from "./PripadyWizardSumarDodatocneInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VCard,VCheckbox,VCol,VContainer,VDivider,VForm,VIcon,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("C:\\azagent\\_work\\3\\s\\master-v3\\Filip.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f939fa42')) {
      api.createRecord('f939fa42', component.options)
    } else {
      api.reload('f939fa42', component.options)
    }
    module.hot.accept("./PripadyWizardSumarDodatocneInfo.vue?vue&type=template&id=f939fa42&", function () {
      api.rerender('f939fa42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pripady_wizard/PripadyWizardSumarDodatocneInfo.vue"
export default component.exports